module.exports=function(scope){ return `// Make sure the FaceTec SDK is initialized before launching the User Session
if(Zoom.sdk.getStatus() == .initialized) {

    // Core function calls that create and launch the FaceTec Interface
    let sessionVC = Zoom.sdk.createSessionVC(delegate: self)

    // When presenting the FaceTec Interface over your own application, you can keep your application showing in the background by using this presentation style
    sessionVC.modalPresentationStyle = UIModalPresentationStyle.overCurrentContext

    // Present FaceTec SDK view controller and capture a session
    self.present(sessionVC, animated: true, completion: nil)
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/ios/02-start-enrollment.swift.tpl